import React, { useState, useEffect } from 'react';
import { Calendar, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import axios from 'axios';
import { AdSenseSkyscraper } from './AdComponents';


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const BlogPreview = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await axios.get(`${API}/articles`);
        setArticles(response.data.slice(0, 3));
      } catch (error) {
        console.error('Erreur lors du chargement des articles:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  const latestArticles = articles;

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex lg:flex-row flex-col gap-8">
          {/* Main Content - 2/3 width */}
          <div className="flex-grow lg:w-2/3">
            {/* Section Header */}
            <div className="mb-12">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-gray-900 mb-4">
                Dernières Publications
              </h2>
              <p className="text-lg text-gray-600">
                Découvrez nos guides, conseils et astuces pour réussir votre apiculture urbaine.
              </p>
            </div>

            {/* Blog Cards Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
              {latestArticles.map((article) => (
                <Link 
                  key={article.id}
                  to={`/blog/${article.slug || article.id}`}
                  className="block"
                >
                  <Card 
                    className="group hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden border-2 hover:border-honey h-full"
                  >
                    {/* Article Image */}
                    <div className="relative h-48 overflow-hidden">
                      <img 
                        src={article.image} 
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                      />
                      <div className="absolute top-3 left-3">
                        <Badge className="bg-honey text-white">{article.category}</Badge>
                      </div>
                    </div>

                    <CardContent className="p-6">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-honey transition-colors line-clamp-2">
                        {article.title}
                      </h3>
                      <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                        {article.excerpt}
                      </p>
                      
                      {/* Meta Info */}
                      <div className="flex items-center text-xs text-gray-500">
                        <div className="flex items-center space-x-1">
                          <Calendar className="h-3 w-3" />
                          <span>{new Date(article.date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                        </div>
                      </div>

                      <div className="mt-4 flex items-center text-honey font-medium text-sm group-hover:underline">
                        Lire l'article
                        <ArrowRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>

            {/* View All Button */}
            <div className="text-center">
              <Link to="/blog">
                <button className="inline-flex items-center px-6 py-3 border-2 border-sage text-sage hover:bg-sage/90 hover:text-cream hover:border-sage/90 font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all">
                  Voir Tous les Articles
                  <ArrowRight className="ml-2 h-5 w-5" />
                </button>
              </Link>
            </div>
          </div>

          {/* Skyscraper Ad - Fixed */}
          <aside className="lg:w-1/3">
            <div className="sticky top-24">
              <AdSenseSkyscraper 
                adClient="ca-pub-8650202956587648"
                adSlot="4628028499"
              />
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
};
